import {ColumnListModel} from './list-column.model';
import {PaginationModel} from './pagination.model';
import moment from 'moment';

export class RequestParamModel {
  pageIndex = 0;
  pageSize?: any;
  sort?: string;
  fields!: string[];
  assignedto?: string[];
  expands!: string[];
  expand!: string[];
  totalCount!: number;
  totalPage!: number;
  filter?: string;
  defaultFilter = '';
  setOrArrayFilter = '';
  setInArrayFilter = '';
  timer: any;
  sorts?: string;
  pageCount?: any;
  group?: any;
  /**
   * Ask a listing to also describe the WHOLE filtered set, not just this page.
   *
   * Emitted as `&summary=true`. The API answers on the same response, as
   * `X-Summary-…` headers built from the same `filters[...]` the rows came from —
   * so a summary line above a table can never describe a different dataset.
   * See utils/listing-summary.util.
   */
  summary?: boolean;

  constructor() {
    this.pageIndex = 0;
    this.pageSize = 20;
  }

  update<T>(pagedList: PaginationModel<T>) {
    this.pageSize = pagedList.pageSize;
    this.totalCount = pagedList.totalCount;
    this.pageIndex = pagedList.currentPage;
    this.totalPage = pagedList.pageCount;
  }

  setFilters(columns: ColumnListModel[]): any {
    this.filter = '';
    this.setInArrayFilter = '';

    for (let i = 0; i < columns.length; i++) {
      const column = columns[i];
      const field = column.searchfield;
      const searchValue = column.searchValue;

      if (column.searchable && searchValue !== undefined && searchValue !== null && searchValue !== '') {
        const encodedValue = encodeURIComponent(String(searchValue).trim());

        // For boolean type columns like 'is_expired' or 'is_deleted'
        if (column.datatype === 'boolean') {
          const boolValue = searchValue ? 'true' : 'false';
          this.filter += `&filters[${field}]=${boolValue}`;
        }

        // For date columns
        else if (column.datatype === 'date') {
          this.filter += `&filters[${field}][date]=${moment(searchValue).format('YYYY-MM-DD')}`;
        }

        // For 'in' type filters (e.g., array filters)
        else if (column.datatype === 'in') {
          if (Array.isArray(searchValue)) {
            searchValue.forEach((value, index) => {
              if (value && value !== ',') {
                this.setInArrayFilter += `&filters[${field}][in][${index}]=${encodeURIComponent(value)}`;
              }
            });
          }
        }

        // For numeric fields (e.g., 'is_tender' or other numeric columns)
        else if (column.datatype === 'number') {
          this.filter += `&filters[${field}]=${encodedValue}`;
        }

        // For non-numeric or non-date fields (default text search with 'like')
        else {
          this.filter += `&filters[${field}][like]=${encodedValue}`;
        }
      }
    }

    // Append the array-based filters (if any) to the final filter
    this.filter += this.setInArrayFilter;
  }

  setFilter(columns: ColumnListModel[]): any {
    this.filter = '';
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].searchable && columns[i].searchValue !== undefined && columns[i].searchValue !== null && columns[i].searchValue !== '') {
        const field = columns[i].searchfield;
        const searchValue = columns[i].searchValue;

        if (columns[i].datatype === 'boolean') {
          const boolValue = searchValue ? 'true' : 'false';
          this.defaultFilter += `&filters[${field}]=${boolValue}`;
        } else if (columns[i].datatype === 'date') {
          this.filter += `&filter[${field}]=${moment(searchValue).format('YYYY-MM-DD')}`;
        } else if (columns[i].datatype === 'in') {
          for (let j = 0; j < searchValue.length; j++) {
            if (searchValue[j] !== '' && searchValue[j] !== ',') {
              this.setInArrayFilter += `&filter[${field}][in][${j}]=${encodeURIComponent(searchValue[j])}`;
            }
          }
        } else if (columns[i].datatype !== 'number') {
          this.filter += `&filter[${field}][like]=${encodeURIComponent(searchValue)}`;
        } else {
          this.filter += `&filter[${field}]=${encodeURIComponent(searchValue)}`;
        }
      }
    }
  }

  // setFilters(columns: ColumnListModel[]): any {
  //   this.filter = '';
  //   let taskCategoryId = ''; // Variable to hold the value of task_category_id if found
  //
  //   for (let i = 0; i < columns.length; i++) {
  //     if (columns[i].searchable && columns[i].searchValue) {
  //       const field = columns[i].searchfield;
  //       const searchValue = encodeURIComponent(columns[i].searchValue);
  //
  //       // Check if the current column is 'task_category_id'
  //       if (field === 'task_category_id') {
  //         taskCategoryId = searchValue; // Store the value for 'task_category_id'
  //       }
  //
  //       if (columns[i].datatype === 'date') {
  //         this.filter += '&filter[' + field + ']' + '=' + moment(columns[i].searchValue).format('YYYY-MM-DD');
  //       } else if (columns[i].datatype == 'in') {
  //         if (searchValue !== undefined) {
  //           for (let j = 0; j < searchValue.length; j++) {
  //             if (searchValue[j] !== '' && searchValue[j] !== ',') {
  //               this.setInArrayFilter += '&filter[' + field + '][in][' + j + ']' + '=' + encodeURIComponent(searchValue[j]);
  //             }
  //           }
  //         }
  //       } else if (columns[i].datatype !== 'number') {
  //         // this.filter += '&filter[' + field + ']' + '=' + searchValue;
  //         this.filter += '&filter[' + field + '][like]' + '=' + searchValue;
  //       } else {
  //         this.filter += '&filter[' + field + ']' + '=' + searchValue;
  //       }
  //     }
  //   }
  // }

  // addDefaultFilter(field: string, value: any, datatype: string) {
  //   if (field && (value || value == 0)) {
  //     if (datatype !== 'number') {
  //       this.defaultFilter += '&filters[' + field + ']' + '[like]' + '=' + value;
  //       // this.defaultFilter += '&filter[' + field + ']' + '[like]' + '=' + value;
  //     } else {
  //       this.defaultFilter += '&filters[' + field + ']' + '=' + value;
  //       // this.defaultFilter += '&filter[' + field + ']' + '=' + value;
  //     }
  //   }
  // }

  addDefaultFilter(field: string, value: any, datatype: string) {
    if (field && (value || value === 0)) {
      if (datatype !== 'number') {
        // this.defaultFilter += '&filter[' + field + ']' + '[like]' + '=' + value;
        this.defaultFilter += '&filter[' + field + ']' + '[like]' + '=' + value;
      } else {
        // this.defaultFilter += '&filter[' + field + ']' + '=' + value;
        this.defaultFilter += '&filter[' + field + ']' + '=' + value;
      }
    }
  }

  addDefaultFilterInWithArray(arr: any, field: any) {
    this.setInArrayFilter = '';
    if (arr !== undefined) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          this.setInArrayFilter += '&filter[' + field + '][in][' + i + ']' + '=' + encodeURIComponent(arr[i]);
        }
      }
    }
  }

  addDefaultFilterNotInWithArray(arr: any, field: any) {
      this.setInArrayFilter = '';
      if (arr !== undefined) {
          for (let i = 0; i < arr.length; i++) {
              if (arr[i] !== '') {
                  // this.setInArrayFilter += '&filter[' + field + '][nin][' + i + ']' + '=' + encodeURIComponent(arr[i]);
                  this.setInArrayFilter += '&filters[' + field + '][nin][' + i + ']' + '=' + encodeURIComponent(arr[i]);
              }
          }
      }
  }

  addFilterNotInWithArray(arr: any[], field: string): void {
    if (arr && arr.length > 0) {
      arr.forEach((value, i) => {
        if (value !== '' && value !== null && value !== undefined) {
          this.defaultFilter += `&filter[${field}][nin][${i}]=${encodeURIComponent(value)}`;
        }
      });
    }
  }

  addDefaultFilters(field: string, value: any, datatype: string) {
    if (field && (value || typeof value === "boolean" && !value)) {
      if (datatype == 'date') {
        this.defaultFilter += '&filters[' + field + ']' + '[date]' + '=' + value;
      } else if (datatype !== 'number') {
        this.defaultFilter += '&filters[' + field + ']' + '[like]' + '=' + value;
      } else {
        this.defaultFilter += '&filters[' + field + ']' + '=' + value;
      }
    }
  }

  removeDefaultFilter(field: string) {
    var removeFilterIndex: any = [];
    if (field && this.defaultFilter) {
      var defaultFilterArray = this.defaultFilter.split('&');
      if (defaultFilterArray.length > 0) {
        defaultFilterArray.forEach(function (value, index) {
          if (value.includes(field)) {
            // removeFilterIndex.push(index);
            defaultFilterArray.splice(index);
          }
        });

        this.defaultFilter = defaultFilterArray.join("&");
      }
    }
  }

  addDefaultSorting(field: string, sortType: string) {
    // Yii's descending marker is a HYPHEN-MINUS. An em dash produces `sort=—field`, which
    // matches no sortable attribute, so the API silently returns the list unsorted.
    this.sorts += (this.sorts != '' ? ',' : '') + (sortType === 'desc' ? '-' : '') + field
  }

  filterInWithArray(arr: any, field: any) {
    this.setInArrayFilter = '';
    if (arr !== undefined) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          this.setInArrayFilter += '&filters[' + field + '][in][' + i + ']' + '=' + encodeURIComponent(arr[i]);
          // this.setInArrayFilter += '&filter[' + field + '][in][' + i + ']' + '=' + encodeURIComponent(arr[i]);
        }
      }
    }
  }

  singleFilterInWithArray(arr: any, field: any) {
    if (arr !== undefined) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          this.setOrArrayFilter += '&filter[' + field + '][in][]' + '=' + encodeURIComponent(arr[i]);
        }
      }
    }
  }

  filterOrWithArray(arr: any, field: any) {
    this.setOrArrayFilter = '';
    if (arr !== undefined) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          this.setOrArrayFilter += '&filters[' + field + '][or][' + i + ']' + '=' + encodeURIComponent(arr[i]);
          // this.setOrArrayFilter += '&filter[' + field + '][or][' + i + ']' + '=' + encodeURIComponent(arr[i]);
        }
      }
    }
  }

  filterNotInWithArray(arr: any, field: any) {
    this.setInArrayFilter = '';
    if (arr !== undefined) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          // this.setInArrayFilter += '&filter[' + field + '][nin][' + i + ']' + '=' + encodeURIComponent(arr[i]);
          this.setInArrayFilter += '&filters[' + field + '][nin][' + i + ']' + '=' + encodeURIComponent(arr[i]);
        }
      }
    }
  }

  removeNotInFilter(field: string) {
    var removeFilterIndex: any = [];
    if (field && this.setInArrayFilter) {
      var defaultFilterArray = this.setInArrayFilter.split('&');
      if (defaultFilterArray.length > 0) {
        defaultFilterArray.forEach(function (value, index) {
          if (value.includes(field)) {
            // removeFilterIndex.push(index);
            defaultFilterArray.splice(index);
          }
        });

        this.setInArrayFilter = defaultFilterArray.join("&");
      }
    }
  }

  setDefaultFiltersDropdown(field: string, value: any, datatype: string) {
    if (field && value) {
      if (datatype !== 'number') {
        if (datatype === 'date') {
          this.defaultFilter += '&filters[dropdown][' + field + ']' + '=' + moment(value).format('YYYY-MM-DD');
          // this.defaultFilter += '&filter[dropdown][' + field + ']' + '=' + moment(value).format('YYYY-MM-DD');
        } else {
          this.defaultFilter += '&filters[dropdown][' + field + ']' + '[like]' + '=' + encodeURIComponent(value);
          // this.defaultFilter += '&filter[dropdown][' + field + ']' + '[like]' + '=' + encodeURIComponent(value);
        }
      } else {
        this.defaultFilter += '&filters[dropdown][' + field + ']' + '=' + encodeURIComponent(value);
        // this.defaultFilter += '&filter[dropdown][' + field + ']' + '=' + encodeURIComponent(value);
      }
    }
  }

  addAssignedtoFilter(field: string, value: any) {
    if (field && value) {
      this.defaultFilter += '&assignedto[' + field + ']' + '=' + encodeURIComponent(value);
    } else if (field) {
      this.defaultFilter += '&assignedto[' + field + ']' + '=' + null;
    }
  }

  resetClear(columns: ColumnListModel[]) {
    this.filter = '';
    for (let i = 0; i < columns.length; i++) {
      columns[i].searchValue = '';
    }

  }

  setSorting(columns: ColumnListModel[]): any {
    this.sorts = '';
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sortOrder && columns[i].sortOrder != '') {
        if (columns[i].property == 'last_login') {
          this.sorts += (this.sorts != '' ? ',' : '') + (columns[i].sortOrder === 'desc' ? '' : '-') + columns[i].property
        } else {
          this.sorts += (this.sorts != '' ? ',' : '') + (columns[i].sortOrder === 'desc' ? '-' : '') + columns[i].property
        }
      }
    }
  }

  resetSorting(columns: ColumnListModel[]) {
    this.sorts = '';
    for (let i = 0; i < columns.length; i++) {
      columns[i].sortOrder = '';
    }

  }

  sortChange(field: string, sortType: string): any {
    if (field) {
      if (field == 'last_login') {
        this.sorts = (sortType === 'desc' ? '' : '-') + field
      } else {
        this.sorts = (sortType === 'desc' ? '-' : '') + field
      }

    }
  }

  getParams(): string {
    // TODO : Optimize to use the URLQueryParams
    let param = '';

    if (this.defaultFilter) {
      param += this.defaultFilter;
    }

    if (this.filter) {
      param += this.filter;
    }
    const fieldParam = this.getListParam('fields', this.fields);
    if (fieldParam) {
      param += '&' + fieldParam;
    }

    const expandsParam = this.getListParam('expands', this.expands);
    if (expandsParam) {
      param += '&' + expandsParam;
    }

    const expandParam = this.getListParam('expand', this.expand);
    if (expandParam) {
      param += '&' + expandParam;
    }

    if (this.sorts) {
      // `sorts` already carries each key's direction (a leading '-' means descending), so
      // nothing is prefixed here. The prefix that used to sit in front was an em dash, and
      // any caller that had triggered it would have sent `sort=—field` — a key matching no
      // sortable attribute, which the API answers with an unsorted list rather than an error.
      param += '&sort=' + this.sorts;
    }

    if (this.pageIndex) {
      param += '&page=' + this.pageIndex;
    }
    if (this.pageSize) {
      param += '&pageSize=' + this.pageSize;
    }
    if (this.group) {
      param += '&group=' + this.group;
    }
    if (this.summary) {
      param += '&summary=true';
    }
    if (param) {
      param = param.replace('&', '?');
    }

    if (this.setInArrayFilter) {
      param += this.setInArrayFilter;
    }

    if (this.setOrArrayFilter) {
      param += this.setOrArrayFilter;
    }

    return param;
  }

  private getListParam(paramName: string, paramValue: string[]): string {
    let param = '';
    if (paramValue) {
      param = paramName + '=' + paramValue.join(',');
    }
    return param;
  }
}
